export interface HybrisConfig {
	baseUrlUS: string;
	baseUrlCA: string;
}

/**
 * Loads the Hybris configuration from environment variables.
 * @returns {HybrisConfig} The Hybris configuration object.
 * @throws {Error} If the Hybris configuration is not set.
 */
export function loadHybrisConfig(): HybrisConfig {
	const { HYBRIS_CA, HYBRIS_US } = process.env;

	if (!HYBRIS_CA || !HYBRIS_US) {
		throw new Error("HYBRIS config is not set.");
	}

	return {
		baseUrlUS: HYBRIS_US,
		baseUrlCA: HYBRIS_CA
	};
}
